const noop = () => void 0

export class Deferred<T> {
	promise: Promise<T>
	reject: (error?: unknown) => void = noop
	resolve: (value: T | PromiseLike<T>) => void = noop

	constructor() {
		this.promise = new Promise((resolve, reject) => {
			this.reject = reject
			this.resolve = resolve
		})
	}
}
